import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import logo from "../Components/Images/logo.png";
import "../index.css";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

function Home() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = () => {
    setError("");
    signInWithEmailAndPassword(auth, email, password)
      .then(() => {
        navigate("/dashboard");
      })
      .catch((err) => {
        setError("Invalid email or password. Please try again.");
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit();
  };

  return (
    <div className="w-screen h-screen flex justify-center items-center">
      <div className="w-2/4 flex flex-col items-center">
        <img src={logo} className="pb-10" alt="Madhur Exports" />
        <h1 className="font-bold text-3xl">Admin Panel</h1>
        {error && (
          <p className="text-red-600 mt-4 text-sm">{error}</p>
        )}
        <input
          type="email"
          placeholder="Email Address"
          className="border py-2 pl-5 w-2/4 my-5"
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <input
          type="password"
          placeholder="Password"
          className="border py-2 pl-5 w-2/4"
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button
          className="w-1/4 border rounded py-2 my-5"
          onClick={handleSubmit}
        >
          Login
        </button>
      </div>
      <div className="w-screen absolute bottom-0 bg-alert-yellow">
        <p className="text-center">
          This page is only for administration use, please do not try to login
        </p>
      </div>
    </div>
  );
}

export default Home;
